module.exports = __webpack_public_path__ + "static/media/Banner2.5de29e42.png";